import { FeatureFlag } from '../enums/FeatureFlag';

export const buildExposureKey = (
  contextKey: string,
  flag: FeatureFlag,
  enabled: boolean,
) => `${contextKey}:${flag}:${enabled ? 1 : 0}`;
